<template>
  <transition :name="transitionName">
    <el-card v-if="visible" :class="['sidebar', 'sidebar-' + this.position]">
      <template class="sidebar-header" v-if="header" v-slot:header>
        <span>{{header}}</span>
      </template>
      <i class="el-icon-menu arrow-switch" @click="togglePosition"></i>
      <i class="el-icon-close arrow-close" @click="hide"></i>
      <slot></slot>
    </el-card>
  </transition>
</template>

<script>
export default {
  name: 'Sidebar',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    adjust: {
      type: Boolean,
      default: true
    },
    header: String,
    direction: {
      type: String,
      default: 'right'
    }
  },
  data () {
    return {
      position: this.direction
    }
  },
  watch: {
    direction (val) {
      this.position = val
    },
    position () {
      this.toggle()
    },
    visible: {
      handler () {
        this.toggle()
      },
      immediate: true
    }
  },
  computed: {
    transitionName () {
      return 'sidebar-' + this.position
    }
  },
  methods: {
    toggle () {
      this.$root.$el.classList.remove('sidebar-open-right', 'sidebar-open-bottom', 'sidebar-adjust')
      if (this.visible) {
        this.$root.$el.classList.add('sidebar-open', 'sidebar-open-' + this.position)
        if (this.adjust) {
          this.$root.$el.classList.add('sidebar-adjust')
        }
      } else {
        this.$root.$el.classList.remove('sidebar-open')
      }
    },
    togglePosition () {
      this.position = this.position === 'right' ? 'bottom' : 'right'
    },
    hide () {
      this.$emit('update:visible', false)
    },
  },
  beforeDestroy () {
    this.$root.$el.classList.remove('sidebar-open', 'sidebar-open-right', 'sidebar-open-bottom', 'sidebar-adjust')
  }
}
</script>

<style lang="scss">
  .sidebar-right-enter, .sidebar-right-leave-to {
    transform: translate(100%, 0);
  }
  .sidebar-bottom-enter, .sidebar-bottom-leave-to {
    transform: translate(0, 100%);
  }
  .sidebar-right-enter-to, .sidebar-right-leave,
  .sidebar-bottom-enter-to, .sidebar-bottom-leave {
    transform: translate(0px, 0px);
    transition: transform .3s;
  }
  .sidebar-right-enter, .sidebar-right-leave-to,
  .sidebar-bottom-enter, .sidebar-bottom-leave-to{
    opacity: 0;
    transition: opacity .3s ease-in-out .3s, transform .3s ease-in-out;
  }
  .sidebar{
    position: relative;
    position: fixed;
    background: white;
    z-index: 999;
    border-radius: 0;
    display: flex;
    flex-direction: column;
    .el-card__body{
      flex: 1;
      overflow-y: auto;
    }
    &.sidebar-right{
      right: 0;
      top: 0;
      bottom: 0;
      width: 50%;
      max-width: 800px;
    }
    &.sidebar-bottom{
      left: 0;
      right: 0;
      bottom: 0;
      height: 50vh;
    }
    .arrow-switch,
    .arrow-close{
      position: absolute;
      right: 15px;
      top:20px;
      z-index: 2;
      &:hover{
        color: #409eff;
        cursor: pointer;
      }
    }
    .arrow-switch{
      right: 40px;
    }
  }
  .sidebar-open-bottom.sidebar-adjust .el-main{
    padding-bottom: 50vh;
    margin-bottom: 20px;
  }
  .sidebar-open-right.sidebar-adjust .el-main{
    padding-right: 50vw;
    margin-right: 20px;
    @media (min-width:1600px) {
      padding-right: 800px;
    }
  }
</style>
